<template>
  <div>
    <span v-for="(authorRow, index) in authorNames" v-bind:key="index">
      <span v-if="authorRow.author_info && authorRow.author_info.author_name">{{ authorRow.author_info.author_name }}</span>
      <span v-if="index + 1 < authorNames.length">, </span>
    </span>
  </div>
</template>
<script>
export default {
  props: {
    authorNames: {
      type: Array,
      required: true,
    },
  },
};
</script>
